"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "align-center flex-gap agent-title" };
const _hoisted_2 = {
    href: "https://7760438.hs-sites-na2.com/knowledge/promptnotes",
    class: "header-question-mark-link",
    target: "_blank"
};
const _hoisted_3 = { class: "agent-content-wrapper" };
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("../../../vue/Modal.vue"));
const provider_1 = require("../../../provider/provider");
const OpenAIIcon_vue_1 = __importDefault(require("../../assets/icons/OpenAIIcon.vue"));
const QuestionMarkCircleIcon_vue_1 = __importDefault(require("../../assets/icons/QuestionMarkCircleIcon.vue"));
const AutoAIAgentChat_vue_1 = __importDefault(require("./AutoAIAgentChat.vue"));
const AutoAIAgentSelector_vue_1 = __importDefault(require("./AutoAIAgentSelector.vue"));
const autoAIAgent_1 = require("./autoAIAgent");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AutoAIAgentModal',
    emits: ["use-prompt"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const viewModel = (0, vue_3.inject)(provider_1.autoAIAgentViewModelInjectKey);
        const presenter = (0, vue_3.inject)(provider_1.autoAIAgentPresenterInjectKey);
        const isVisible = (0, vue_3.computed)(() => {
            return viewModel?.value.isVisible ?? false;
        });
        const screen = (0, vue_3.computed)(() => {
            return viewModel?.value.screen;
        });
        const title = (0, vue_3.computed)(() => {
            return viewModel?.value.currentAgent?.Name || 'シフトエージェント';
        });
        function closeModal() {
            presenter?.close();
        }
        function handleUsePrompt(prompt) {
            emit('use-prompt', prompt);
        }
        return (_ctx, _cache) => {
            return (isVisible.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                    key: 0,
                    "modal-name": "auto-ai-agent-modal",
                    "has-title-divider": true,
                    "include-modal-footer": false,
                    "close-on-overlay-click": false,
                    onCloseModal: closeModal
                }, {
                    "header-title": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_1, [
                            (0, vue_2.createVNode)(OpenAIIcon_vue_1.default),
                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(title.value) + " ", 1 /* TEXT */),
                            (0, vue_2.createElementVNode)("a", _hoisted_2, [
                                (0, vue_2.createVNode)(QuestionMarkCircleIcon_vue_1.default)
                            ])
                        ])
                    ]),
                    content: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                            (screen.value === (0, vue_2.unref)(autoAIAgent_1.AutoAIAgentScreen).SELECTOR)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(AutoAIAgentSelector_vue_1.default, { key: 0 }))
                                : (screen.value === (0, vue_2.unref)(autoAIAgent_1.AutoAIAgentScreen).CHAT)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(AutoAIAgentChat_vue_1.default, {
                                        key: 1,
                                        onUsePrompt: handleUsePrompt
                                    }))
                                    : (0, vue_2.createCommentVNode)("v-if", true)
                        ])
                    ]),
                    _: 1 /* STABLE */
                }))
                : (0, vue_2.createCommentVNode)("v-if", true);
        };
    }
});
